import { useTheme } from '@mui/styles';
import { nortadaLogger } from '../logger';

import { OPERATION_STATUS } from '../status/interfaces';

import CostItem from './costItem';

interface Props {
  operationStatus: OPERATION_STATUS;
  value: string;
}

const Cost = ({ operationStatus, value }: Props) => {
  const theme = useTheme();

  switch (operationStatus.toUpperCase()) {
    case OPERATION_STATUS.UNKNOWN: {
      return <CostItem value={value} color={theme.customTypography.disabled.color} />;
    }
    case OPERATION_STATUS.SUCCESS:
    case OPERATION_STATUS.FAILURE: {
      return <CostItem value={value} />;
    }

    default: {
      nortadaLogger.warn(
        `Cost component rendered with warning.
        Operation status: ${operationStatus} is none of the known statuses.
        Possible operation statuses: 'SUCCESS' | 'FAILURE' | 'UNKNOWN'`
      );

      return <CostItem value={value} />;
    }
  }
};

export default Cost;
